export default __webpack_public_path__ + "static/media/1770.5b503470.png";